import base from 'components/base'
import componentInit from 'components/componentInit'
import main from 'main'
import $ from 'jquery'

class externalLink extends base
{
  element = null

  constructor(element)
  {
    super()

    this.element = $(element).get(0)
    this.bindEvents()
  }

  bindEvents()
  {
    $(this.element).on('click.'+ module.id, (event) =>
    {
      let href = $(this.element).attr('href')
      let target = $(this.element).attr('target')
      if(!target || target !== '_blank')
        event.preventDefault()

      gtag('event', 'externalLink', {
        event_label: href,
        event_callback: () =>
        {
          if(!target || target !== '_blank')
            window.location = href
        }
      })
    })
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  if(typeof gtag === 'function')
  {
    let elements = $(parentElement).find('a:not([href^="'+ main.framework.application.applicationUrl.replace(/\/*$/, '') +'"])').get()
    for(let element of elements)
    {
      let href = $(element).attr('href')
      if(href && href.match(/^http/i))
        new externalLink(element)
    }
  }
}

export default externalLink



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/externalLink.js